module.exports = __webpack_public_path__ + "static/media/header_2.d49f2d8d.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/header_2.gif
// module id = 650
// module chunks = 0